import React from "react";
import RouterLink from "gatsby-link";
import styled from "styled-components";

const ProjectItem = ({ image, title, subtitle, url }) => (
  <Link to={url}>
    <img src={image} alt={title} />
    <Overlay>
      <Center>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </Center>
    </Overlay>
  </Link>
);

const Overlay = styled.div`
  opacity: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  transition: all 0.2s ease;
`;

const Link = styled(RouterLink)`
  flex: 1 0 30%;
  text-decoration: none;
  transition: all 0.25s ease;
  line-height: 0;
  position: relative;
  @media (min-width: 1000px) {
    &:hover ${Overlay} {
      opacity: 1;
    }
  }
`;

const Center = styled.div`
  text-align: center;
`;

const Title = styled.h2`
  color: var(--black);
  line-height: 1;
  margin: 0;
`;

const Subtitle = styled.p`
  line-height: 1;
  color: var(--link-color);
  margin: 0.5em 0 0 0;
`;

export default ProjectItem;



// WEBPACK FOOTER //
// ./src/components/ProjectItem/index.js